<template>
  <textarea
    class="text-area"
    :value="value"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.text-area {
  display: block;
  width: 100%;
  min-height: 36px;
  padding: 5px 10px;
  background: #FFF;
  border: 1px solid #CCC;
  border-radius: 5px;
  letter-spacing: inherit;
  word-spacing: inherit;
  line-height: inherit;
  font: inherit;
  outline: none;
  resize: vertical;
  font-size: 14px;
  white-space: pre-wrap;
  overflow-wrap: break-word;

  &:focus {
    border-color: #007E57
  }
}
</style>
